import { generateId } from './generateId';
import objLetters from './objLetters';
import axiosResponse from './axiosResponse';
import varTypes from './varTypes';
import { createByFieldSorter } from './createByFieldSorter';
import { toTwoPrecision } from './toTwoPrecision';

export default {
  generateId,
  ...objLetters,
  ...axiosResponse,
  ...varTypes,
  createByFieldSorter,
  toTwoPrecision
};
